// ErrorPage.tsx

import React from "react";

const ErrorPage: React.FC = () => {
  return (
    <div className="flex items-center justify-center flex-col mx-auto gap-12 ">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-48 h-48 stroke-destructive stroke-2"
      >
        <path d="m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71" />
        <path d="m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71" />
        <line x1="8" x2="8" y1="2" y2="5" />
        <line x1="2" x2="5" y1="8" y2="8" />
        <line x1="16" x2="16" y1="19" y2="22" />
        <line x1="19" x2="22" y1="16" y2="16" />
      </svg>
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Error</h1>
        <p className="text-gray-600">
          Oops! Something went wrong. Please try again later.
        </p>
      </div>
    </div>
  );
};

export default ErrorPage;
